function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M13 3.3335C13 3.15668 12.9298 2.98712 12.8047 2.86209C12.6797 2.73707 12.5101 2.66683 12.3333 2.66683H6C5.91039 2.66683 5.8217 2.64877 5.73922 2.61372C5.65675 2.57867 5.58219 2.52735 5.52 2.46283L4.62533 1.5375C4.56314 1.47298 4.48858 1.42166 4.40611 1.38661C4.32364 1.35156 4.23495 1.33349 4.14533 1.3335H1.85733C1.62995 1.3335 1.41189 1.42382 1.25111 1.5846C1.09033 1.74538 1 1.96345 1 2.19083V9.8095C1 10.0369 1.09033 10.2549 1.25111 10.4157C1.41189 10.5765 1.62995 10.6668 1.85733 10.6668H12.1427C12.2553 10.6668 12.3667 10.6447 12.4708 10.6016C12.5748 10.5585 12.6693 10.4953 12.7489 10.4157C12.8285 10.3361 12.8917 10.2416 12.9347 10.1376C12.9778 10.0336 13 9.92208 13 9.8095V3.3335Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.290474fd.svg";
export { ForwardRef as ReactComponent };